var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.3338V26.2054C0 26.6814 0.189093 27.1379 0.52568 27.4745C0.862268 27.8111 1.31878 28.0002 1.79479 28.0002H4.66644C5.13985 27.9935 5.59142 27.7999 5.92279 27.4618L22.8835 10.5011L17.4992 5.1167L0.538436 22.0774C0.200272 22.4088 0.00674309 22.8604 0 23.3338Z",
    fill: "#CB34FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4602 3.41144L24.5885 0.539786C24.4267 0.369258 24.2318 0.233458 24.0159 0.140658C23.7999 0.0478578 23.5672 0 23.3322 0C23.0971 0 22.8644 0.0478578 22.6485 0.140658C22.4325 0.233458 22.2376 0.369258 22.0758 0.539786L19.2939 3.3217L24.6782 8.70606L27.4602 5.92414C27.6307 5.76232 27.7665 5.56748 27.8593 5.35149C27.9521 5.1355 27.9999 4.90287 27.9999 4.66779C27.9999 4.43271 27.9521 4.20008 27.8593 3.98409C27.7665 3.7681 27.6307 3.57326 27.4602 3.41144Z",
    fill: "#CB34FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.644fcb8888ac2f3ea98b605ee4ab7ec6.svg";
export { ForwardRef as ReactComponent };